/*
 * lib/fab-pref.js
 *
 * Per-device voorkeur voor welke kant de floating action-knop staat.
 * Bewust niet in profile-settings — dit hangt af van de hand waarmee je
 * je gsm vasthoudt, niet van je account. Twee toestellen = mogelijk twee
 * voorkeuren.
 */

const KEY = 'florijn:fab-side';

export function readFabSide() {
  if (typeof localStorage === 'undefined') return 'right';
  try {
    const v = localStorage.getItem(KEY);
    return v === 'left' ? 'left' : 'right';
  } catch {
    return 'right';
  }
}

export function writeFabSide(side) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(KEY, side === 'left' ? 'left' : 'right');
  } catch {}
}
